/* 图片详情变量配置 */
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

export const TUPIAN_DETAIL = {

  /* 说明 */
  CAPTION: {
    TAB: [
      {
        label: '声明',
        id:1
      },
      {
        label: '特殊说明',
        id:2
      },
      {
        label: '作品标签',
        id:3
      },
    ],

    /* 声明固定文案 */
    STATEMENT: [
      '潮国创意是商用版权素材库，该素材为潮国创意原创或已获得相关权利人授权，作品（含预览图）受著作权法保护，著作权及相关权利归本网站所有，未经许可任何人不得擅自使用。作品中的字体仅供参考，如需商用请自行确定版权。',
      ' 水印说明：图片水印仅用于防盗防刷，不代表其他含义。',
    ],

    // 特殊说明文案
    EXPLAIN: [
        '非营利使用：仅限用于公益宣传、事实陈述等非商业化领域，禁止用于任何具有营利性、含有商业化目的以及违反相关法律法规等用途。',
      `特殊说明：潮国创意仅对作品中独创性部分享有著作权，对作品中含有的国旗、国徽、警徽等政治图案不享有权利，仅作为作品整体效果的示例展示，禁止商用。另外您必须遵循相关法律法规规定的使用范围和使用方式，禁止以任何形式歪曲、篡改，详情参见中华人民共和国 国旗法、 国徽法、 警徽管理规定。`

    ]


  },

  /* 运营者id */
  OPERATOR: [
    'P86792518',
    'P11097956',
    'P93979636',
    'maclocch',
    'P23788904',
    'P19364153',
    'h2lihnf0',
    'o0p9xkt1',
    'P25056447',
    'P62591867',
    'P18695918',
  ],


  /* 企业权益 */
  COMPANY_EQUITY: {
    LIST:[
      '企业新媒体用途',
      '企业电商平台',
      '企业线上推广',
      '企业物料印刷',
      '企业线下活动',
      '企业户外广告',
      '企业影视制作',
      '企业传媒平台宣传',
      '企业实物印刷',
      '企业商品生产',
      '企业产品内置',
    ],
    /* 企业线上版 */
    3:[1,1,1,0,0,0,0,0,0,0,0],
    /* 企业全用途版 */
    // 4:[1,1,1,1,1,0,0,0,0,0,0],
    /* 标准版 */
    5:[1,1,1,1,1,0,0,0,0,0,0],
    /* 标准版 */
    2:[1,1,1,1,1,0,0,0,0,0,0],
    /* 升级版 */
    6:[1,1,1,1,1,1,0,0,0,0,0],
    /* 高级版 */
    7:[1,1,1,1,1,1,1,1,0,0,0],
    /* 转售版 */
    8:[1,1,1,1,1,1,1,1,1,1,1]

  },
  BUSINESS_EQUITY: {
    LIST:[
      '个人新媒体用途',
      '个人电商平台',
      '个人线上推广',
      '个人物料印刷',
      '个人线下活动',
      '个人户外广告',
    ]
  },

  /* 授权对比 */
  EQUITY_LIST:[
    {
      className: 'person',
      label: '个人VIP',

      title:'下载范围',
      list: [
        {
          isCheck: true,
          label: '免费专区+个人VIP专区'
        }
      ],
      title2:'个人授权范围',
      list2:[
        {
          isCheck: true,
          label: '限学习交流'
        },
        {
          isCheck: false,
          label: '个人新媒体用途'
        },
        {
          isCheck: false,
          label: ''
        },

        {
          isCheck: false,
          label: '个人电商用途'
        },
        {
          isCheck: false,
          label: ''
        },
        {
          isCheck: false,
          label: '个人企业办公'
        },
        {
          isCheck: false,
          label: ''
        },
        {
          isCheck: false,
          label: '个人广告宣传'
        },
      ]


    },
    /*{
      className: 'person',
      label: '商用VIP',

      title:'下载范围',
      list: [
        {
          isCheck: true,
          label:  '免费专区+普通VIP专区+商用VIP专区'
        }
      ],
      title2:'商用授权范围',
      list2:[
        {
          isCheck: true,
          label: '个人新媒体用途'
        },
        {
          isCheck: false,
          label: '企业新媒体用途'
        },
        {
          isCheck: true,
          label: '个人电商用途'
        },
        {
          isCheck: false,
          label: '企业电商用途'
        },
        {
          isCheck: true,
          label: '个人办公提案'
        },
        {
          isCheck: false,
          label: '企业办公提案'
        },
        {
          isCheck: true,
          label: '个人广告宣传'
        },
        {
          isCheck: false,
          label: '企业广告宣传'
        },
      ]


    },*/
    {
      className: 'company',
      label: '企业VIP',
      title:'下载范围',
      list: [
        {
          isCheck: true,
          label: '免费专区+个人VIP专区+企业商用专区'
        }
      ],
      title2:'企业授权范围（发行版）',
      list2:[
        {
          isCheck: true,
          label: '企业新媒体用途'
        },
        {
          isCheck: true,
          label: '企业线下用途'
        },
        {
          isCheck: true,
          label: '企业电商用途'
        },
        {
          isCheck: true,
          label: '企业传媒影视'
        },
        {
          isCheck: true,
          label: '企业办公提案'
        },
        {
          isCheck: true,
          label: '企业转售商品'
        },
        {
          isCheck: true,
          label: '企业广告宣传'
        },
      ]


    },
  ],

  /* 企业VIP授权范围对比 */
  COMPANY_EQUITY_COMPARE: {
    CATEGORY: [
      '新媒体用途',
      '电商平台',
      '线上推广',
      '物料印刷',
      '线下活动',
      '户外广告',
      '影视制作',
      '传媒平台',
      '实物印刷',
      '商品生产',
      '产品内置',
      '其他用途',
    ],

    LIST:[
      {
        label: '标准版',
        type: ['8','2'],
        ID: VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID,
        list: [1,1,1,1,1,0,0,0,0,0,0,0]
      },
      {
        label: '升级版',
        type: ['5'],
        ID: VIP_MANAGE.COMPANY.UPGRADE.ID,
        list: [1,1,1,1,1,1,0,0,0,0,0,0]
      },
      {
        label: '高级版',
        type: ['6'],
        ID: VIP_MANAGE.COMPANY.SENIOR.ID,
        list: [1,1,1,1,1,1,1,1,0,0,0,0]
      },
      {
        label: '转售版',
        type: ['7'],
        ID: VIP_MANAGE.COMPANY.RESALE.ID,
        list: [1,1,1,1,1,1,1,1,1,1,1,0]

      },
      {
        label: '定制版',
        type: [],
        list: [1,1,1,1,1,1,1,1,1,1,1,1]
      },
    ]
  }

}
